import { apiGet } from "../../utils"

export function getOnlineUsersAdminAPI() {
    return apiGet('/api/getOnlineUsersAdmin')
}
